module.exports = Clipboard;


//////////////////
// WEBPACK FOOTER
// external "Clipboard"
// module id = 52
// module chunks = 1